/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{calcLength as n}from"./delta-calc.js";function t(n){return 0===n.translate&&1===n.scale}function r(n){return t(n.x)&&t(n.y)}function x(n,t){return n.x.min===t.x.min&&n.x.max===t.x.max&&n.y.min===t.y.min&&n.y.max===t.y.max}function m(t){return n(t.x)/n(t.y)}export{m as aspectRatio,x as boxEquals,r as isDeltaZero};
//# sourceMappingURL=utils.js.map
